import {NgModule} from '@angular/core';
import {LayoutComponent} from './layout.component';
import {SidebarComponent} from './sidebar/sidebar.component';
import {OffsidebarComponent} from './offsidebar/offsidebar.component';
import {HeaderComponent} from './header/header.component';
import {FooterComponent} from './footer/footer.component';
import {UserblockComponent} from './sidebar/userblock/userblock.component';
import {NavsearchComponent} from './header/navsearch/navsearch.component';
import {SharedModule} from "../shared/shared.module";
import {UserblockService} from "./sidebar/userblock/userblock.service";

@NgModule({
    imports: [
        SharedModule
    ],
    providers: [
        UserblockService
    ],
    declarations: [
        LayoutComponent,
        SidebarComponent,
        OffsidebarComponent,
        HeaderComponent,
        FooterComponent,
        UserblockComponent,
        NavsearchComponent
    ],
    exports: [
        LayoutComponent,
        SidebarComponent,
        UserblockComponent,
        HeaderComponent,
        NavsearchComponent,
        OffsidebarComponent,
        FooterComponent
    ]
})

export class LayoutModule {
}
